import { IOfferForClientSchema } from '@cian/chats-api/lib/shared/messages/OfferForClientSchema';
import { RoundButton } from '@cian/ui-kit';
import { IconActionChevronLeft16, IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import { clsx } from 'clsx';
import * as React from 'react';

import styles from './OfferGallery.css';
import { TMessage, TOutcomingStatus } from '../../../../types/messages';
import { OfferMessageContainer } from '../../../OfferMessageContainer';

interface IOfferGalleryProps {
  offers?: IOfferForClientSchema[];
  isRead?: boolean;
  animation?: boolean;
  messageId: string;
  message: TMessage & { status: TOutcomingStatus };
  scrollStyles: { hideLeft: boolean; hideRight: boolean };
  onScrollLeft: VoidFunction;
  onScrollRight: VoidFunction;
}

export const OfferGallery = React.forwardRef<HTMLDivElement, IOfferGalleryProps>(function OfferGallery(
  { offers, isRead, animation, messageId, message, scrollStyles, onScrollLeft, onScrollRight },
  galleryRef,
) {
  return (
    <div className={styles['container']} data-name="OfferGalleryContainer">
      <div className={styles['inner']}>
        <div
          className={clsx(
            styles['round-button-left'],
            scrollStyles.hideLeft && styles['hidden'],
            animation && styles['button-animation'],
          )}
          data-testid="left-arrow"
        >
          <RoundButton size="M" title="" icon={<IconActionChevronLeft16 />} onClick={onScrollLeft} />
        </div>
        <div className={clsx(styles['gallery-container'])} ref={galleryRef}>
          <div className={clsx(styles['gallery'], animation && styles['container-animation'])}>
            {offers?.map((offer, index) => (
              <div className={clsx(styles['bubble'], !isRead && clsx(styles['unread-bubble']))} key={index}>
                <OfferMessageContainer key={index} messageId={messageId} message={{ ...message, offers: [offer] }} />
              </div>
            ))}
          </div>
        </div>
        <div
          className={clsx(styles['round-button-right'], scrollStyles.hideRight && styles['hidden'])}
          data-testid="right-arrow"
        >
          <RoundButton size="M" title="" icon={<IconActionChevronRight16 />} onClick={onScrollRight} />
        </div>
      </div>
    </div>
  );
});
